import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuctionCardComponent } from './component/auction-card/auction-card.component';
import { CoreModule } from '../../core/core.module';
import { RouterModule } from '@angular/router';
import { PublicFooterComponent } from './component/layout/public-footer/public-footer.component';
import { PublicHeaderComponent } from './component/layout/public-header/public-header.component';
import { MatMenuModule } from '@angular/material/menu';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AuctionDetailsComponent } from './component/auction-details/auction-details.component';
import { CommonSharedModule } from '../../shared/shared.module';
import { LotCardComponent } from './component/lot-card/lot-card.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CountdownModule } from 'ngx-countdown';
import { MatInputModule } from '@angular/material/input';
import { ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { LotConnectionModeComponent } from './component/lot-connection-mode/lot-connection-mode.component';


const components = [AuctionCardComponent, PublicHeaderComponent, PublicFooterComponent, AuctionDetailsComponent, LotCardComponent, LotConnectionModeComponent];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    CoreModule,
    CommonSharedModule,
    ReactiveFormsModule,
    RouterModule,
    MatMenuModule,
    MatFormFieldModule,
    AccordionModule.forRoot(),
    MatInputModule,
    CountdownModule,
    BsDropdownModule.forRoot(),
  ],
  exports: [
    ...components
  ]
})
export class PublicSharedModule { }
